// import React from 'react';

// export default function Brands({ data }) {
//   return (
//     <div className="cs_brands cs_style_1">
//       {data.map((item, index) => (
//         <div className="cs_brand" key={index}>
//           <img src={item.logoSrc} alt={item.logoAlt} />
//         </div>
//       ))}
//     </div>
//   );
// }


// import React from 'react';
// import './Brands.css';

// export default function Brands({ data }) {
//   // Duplicate the array to loop smoothly
//   const duplicatedData = [...data, ...data];

//   return (
//     <div className="brands-marquee">
//       <div className="brands-track">
//         {duplicatedData.map((item, index) => (
//           <div className="brand-logo" key={index}>
//             <img src={item.logoSrc} alt={item.logoAlt} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }



// import React from 'react';
// import './Brands.css';

// export default function Brands({ data }) {
//   const duplicatedData = [...data, ...data]; // Duplicate for seamless scroll

//   return (
//     <div className="brands-marquee">
//       <div className="brands-track">
//         {duplicatedData.map((item, index) => (
//           <div className="brand-logo" key={index}>
//             <img src={item.logoSrc} alt={item.logoAlt} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useRef } from 'react';
import './Brands.css';

export default function Brands({ data }) {
  const duplicatedData = [...data, ...data];
  const trackRef = useRef(null);

  useEffect(() => {
    if (trackRef.current) {
      const logoCount = data.length;
      trackRef.current.style.setProperty('--logo-count', logoCount);
    }
  }, [data]);

  return (
    <div className="brands-marquee">
      <div className="brands-track" ref={trackRef}>
        {duplicatedData.map((item, index) => (
          <div className="brand-logo" key={index}>
            <img src={item.logoSrc} alt={item.logoAlt} />
          </div>
        ))}
      </div>
    </div>
  );
}
